import CreateCustomer from './Create';
export default CreateCustomer;